import { render, staticRenderFns } from "./SourcePictureView.vue?vue&type=template&id=797abee0&scoped=true&"
import script from "./SourcePictureView.vue?vue&type=script&lang=js&"
export * from "./SourcePictureView.vue?vue&type=script&lang=js&"
import style0 from "./SourcePictureView.vue?vue&type=style&index=0&id=797abee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797abee0",
  null
  
)

export default component.exports